import {
    CONNECT_ACCOUNT_PENDING,
    CONNECT_ACCOUNT_REJECTED,
    CONNECT_ACCOUNT_STATUS_PENDING,
    CONNECT_ACCOUNT_STATUS_REJECTED,
    CONNECT_ACCOUNT_STATUS_SUCCESS,
    CONNECT_ACCOUNT_SUCCESS,
    GET_AUTOMATED_SETTING_ERROR,
    GET_AUTOMATED_SETTING_START,
    GET_AUTOMATED_SETTING_SUCCESS,
    GET_CONNECT_ACCOUNT_PENDING,
    GET_CONNECT_ACCOUNT_REJECTED,
    GET_CONNECT_ACCOUNT_SUCCESS,
    GET_COUNTRY_SPEC_PENDING,
    GET_COUNTRY_SPEC_REJECTED,
    GET_COUNTRY_SPEC_SUCCESS,
    GET_STRIPE_SUBSCRIPTION_STATUS_PENDING,
    GET_STRIPE_SUBSCRIPTION_STATUS_REJECTED,
    GET_STRIPE_SUBSCRIPTION_STATUS_SUCCESS,
    GET_DETAILS,
    GET_PENDING,
    GET_PRICING_ERROR,
    GET_PRICING_START,
    GET_PRICING_SUCCESS,
    GET_REJECTED,
    CANCEL_STRIPE_DOWNGRADE_PENDING,
    CANCEL_STRIPE_DOWNGRADE_REJECTED,
    CANCEL_STRIPE_DOWNGRADE_SUCCESS,
    CANCEL_STRIPE_SUBSCRIPTION_PENDING,
    CANCEL_STRIPE_SUBSCRIPTION_REJECTED,
    CANCEL_STRIPE_SUBSCRIPTION_SUCCESS,
    CREATE_STRIPE_CHECKOUT_SESSION_PENDING,
    CREATE_STRIPE_CHECKOUT_SESSION_REJECTED,
    CREATE_STRIPE_CHECKOUT_SESSION_SUCCESS,
    CREATE_STRIPE_CHECKOUT_SESSION_RESET,
    PREVIEW_STRIPE_PLAN_CHANGE_PENDING,
    PREVIEW_STRIPE_PLAN_CHANGE_REJECTED,
    PREVIEW_STRIPE_PLAN_CHANGE_RESET,
    PREVIEW_STRIPE_PLAN_CHANGE_SUCCESS,
    INSTA_RES,
    RESET_INSTA_FILES,
    RESUME_STRIPE_SUBSCRIPTION_PENDING,
    RESUME_STRIPE_SUBSCRIPTION_REJECTED,
    RESUME_STRIPE_SUBSCRIPTION_SUCCESS,
    UPDATE_AUTOMATED_SETTING_ERROR,
    UPDATE_AUTOMATED_SETTING_START,
    UPDATE_AUTOMATED_SETTING_SUCCESS,
    UPDATE_DETAILS,
    UPDATE_PENDING,
    UPDATE_REJECTED,
} from './types';

const initialState = {
    businessDetails: null,
    fetchLoading: false,
    updateLoading: false,
    isSettingUpdating: false,
    instaImgFiles: [],
    isLoading: false,
    automatedSettings: null,
    isPriceLoading: false,
    pricing: [],
    countrySpecs: null,
    accountStatus: null,
    connectAccount: null,
    subscriptionStatus: null,
    subscriptionStatusLoading: false,
    checkoutSessionLoading: false,
    checkoutSessionLoadingFor: null,
    planPreviewLoading: false,
    planPreview: null,
    resumeSubscriptionLoading: false,
    cancelDowngradeLoading: false,
    cancelSubscriptionLoading: false,
};

const detailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PENDING:
            return {
                ...state,
                fetchLoading: true,
            };
        case RESET_INSTA_FILES:
            return {
                ...state,
                instaImgFiles: [],
            };
        case INSTA_RES:
            return {
                ...state,
                instaImgFiles: action.payload,
            };
        case GET_DETAILS:
            return {
                ...state,
                fetchLoading: false,
                businessDetails: action.payload,
            };
        case GET_REJECTED:
            return {
                ...state,
                fetchLoading: false,
            };

        //Update Info /delete Images
        case UPDATE_PENDING:
            return {
                ...state,
                updateLoading: true,
            };
        case UPDATE_DETAILS:
            return {
                ...state,
                updateLoading: false,
            };
        case UPDATE_REJECTED:
            return {
                ...state,
                updateLoading: false,
            };
        case GET_AUTOMATED_SETTING_START:
            return {
                ...state,
                isLoading: true,
            };
        case GET_AUTOMATED_SETTING_SUCCESS:
            return {
                ...state,
                automatedSettings: action.payload,
                isLoading: false,
            };
        case GET_AUTOMATED_SETTING_ERROR:
            return {
                ...state,
                automatedSettings: null,
                isLoading: false,
            };
        case UPDATE_AUTOMATED_SETTING_START:
            return {
                ...state,
                isSettingUpdating: true,
            };
        case UPDATE_AUTOMATED_SETTING_SUCCESS:
        case UPDATE_AUTOMATED_SETTING_ERROR:
            return {
                ...state,
                isSettingUpdating: false,
            };
        case GET_PRICING_START:
            return {
                ...state,
                isPriceLoading: true,
                pricing: [],
            };
        case GET_PRICING_SUCCESS:
            return {
                ...state,
                isPriceLoading: false,
                pricing: action.payload,
            };
        case GET_PRICING_ERROR:
            return {
                ...state,
                isPriceLoading: false,
            };
        case GET_COUNTRY_SPEC_PENDING:
            return {
                ...state,
                isLoading: true,
            };
        case GET_COUNTRY_SPEC_SUCCESS:
            return {
                ...state,
                countrySpecs: action.payload,
                isLoading: false,
            };
        case GET_COUNTRY_SPEC_REJECTED:
            return {
                ...state,
                isLoading: false,
            };
        case CONNECT_ACCOUNT_PENDING:
            return {
                ...state,
                isLoading: true,
            };
        case CONNECT_ACCOUNT_SUCCESS:
            return {
                ...state,
                isLoading: false,
            };
        case CONNECT_ACCOUNT_REJECTED:
            return {
                ...state,
                isLoading: false,
            };
        case CONNECT_ACCOUNT_STATUS_PENDING:
            return {
                ...state,
                isLoading: true,
            };
        case CONNECT_ACCOUNT_STATUS_SUCCESS:
            return {
                ...state,
                accountStatus: action.payload,
                isLoading: false,
            };
        case CONNECT_ACCOUNT_STATUS_REJECTED:
            return {
                ...state,
                isLoading: false,
            };

        case GET_STRIPE_SUBSCRIPTION_STATUS_PENDING:
            return {
                ...state,
                subscriptionStatusLoading: true,
            };
        case GET_STRIPE_SUBSCRIPTION_STATUS_SUCCESS:
            return {
                ...state,
                subscriptionStatus: action.payload,
                subscriptionStatusLoading: false,
            };
        case GET_STRIPE_SUBSCRIPTION_STATUS_REJECTED:
            return {
                ...state,
                subscriptionStatusLoading: false,
            };

        case CREATE_STRIPE_CHECKOUT_SESSION_PENDING:
            return {
                ...state,
                checkoutSessionLoading: true,
                checkoutSessionLoadingFor: action.payload || null,
            };
        case CREATE_STRIPE_CHECKOUT_SESSION_SUCCESS:
        case CREATE_STRIPE_CHECKOUT_SESSION_REJECTED:
        case CREATE_STRIPE_CHECKOUT_SESSION_RESET:
            return {
                ...state,
                checkoutSessionLoading: false,
                checkoutSessionLoadingFor: null,
            };

        case PREVIEW_STRIPE_PLAN_CHANGE_PENDING:
            return {
                ...state,
                planPreviewLoading: true,
                planPreview: null,
            };
        case PREVIEW_STRIPE_PLAN_CHANGE_SUCCESS:
            return {
                ...state,
                planPreviewLoading: false,
                planPreview: action.payload,
            };
        case PREVIEW_STRIPE_PLAN_CHANGE_REJECTED:
        case PREVIEW_STRIPE_PLAN_CHANGE_RESET:
            return {
                ...state,
                planPreviewLoading: false,
                planPreview: null,
            };

        case RESUME_STRIPE_SUBSCRIPTION_PENDING:
            return {
                ...state,
                resumeSubscriptionLoading: true,
            };
        case RESUME_STRIPE_SUBSCRIPTION_SUCCESS:
        case RESUME_STRIPE_SUBSCRIPTION_REJECTED:
            return {
                ...state,
                resumeSubscriptionLoading: false,
            };

        case CANCEL_STRIPE_DOWNGRADE_PENDING:
            return {
                ...state,
                cancelDowngradeLoading: true,
            };
        case CANCEL_STRIPE_DOWNGRADE_SUCCESS:
        case CANCEL_STRIPE_DOWNGRADE_REJECTED:
            return {
                ...state,
                cancelDowngradeLoading: false,
            };

        case CANCEL_STRIPE_SUBSCRIPTION_PENDING:
            return {
                ...state,
                cancelSubscriptionLoading: true,
            };
        case CANCEL_STRIPE_SUBSCRIPTION_SUCCESS:
        case CANCEL_STRIPE_SUBSCRIPTION_REJECTED:
            return {
                ...state,
                cancelSubscriptionLoading: false,
            };

        case GET_CONNECT_ACCOUNT_PENDING:
            return {
                ...state,
                isLoading: true,
            };
        case GET_CONNECT_ACCOUNT_SUCCESS:
            return {
                ...state,
                connectAccount: action.payload,
                isLoading: false,
            };
        case GET_CONNECT_ACCOUNT_REJECTED:
            return {
                ...state,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default detailsReducer;
